import apiClient from '../../../lib/client';

export const electionsAdminAPI = {
  // Elections
  updateElection: (id, data) => apiClient.patch(`/elections/${id}`, data).then((r) => r.data),

  // Voting hours (ElectionScheduleWindow)
  createVotingHours: (electionId, data) =>
    apiClient.post(`/elections/${electionId}/voting-hours`, data).then((r) => r.data),
  updateVotingHours: (electionId, windowId, data) =>
    apiClient.patch(`/elections/${electionId}/voting-hours/${windowId}`, data).then((r) => r.data),
  deleteVotingHours: (electionId, windowId) =>
    apiClient.delete(`/elections/${electionId}/voting-hours/${windowId}`).then((r) => r.data),
};
